import {PageShell} from '@/components/layout/page-shell.js';
import {Skeleton} from '@/components/ui/skeleton.js';

/**
 * Shown while a lazily loaded route chunk is fetched.
 *
 * @returns The rendered placeholder.
 */
export function RouteFallback(): React.JSX.Element {
  return (
    <PageShell>
      <div className="mx-auto w-full max-w-6xl space-y-4 px-4 py-10">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-96 w-full" />
      </div>
    </PageShell>
  );
}
